import React from 'react';

const SendReply = () => {
    return (
        <svg width={20} height={20} viewBox="0 0 20 20">
            <path
                d="M7.127 12.751v.857a.716.716 0 01-.436.733.783.783 0 01-.291.081.629.629 0 01-.509-.244L.218 7.784a.854.854 0 010-1.14L5.927.25a.569.569 0 01.764-.163.751.751 0 01.436.733v.855l-4.4 5.009a.854.854 0 000 1.14zM20 13.24a9.859 9.859 0 01-.182 1.67 10.318 10.318 0 01-.436 1.711 10.943 10.943 0 01-.545 1.548c-.182.529-.364.9-.436 1.14l-.218.489a.375.375 0 01-.327.2h-.109a.392.392 0 01-.255-.407c.327-3.34-.073-5.7-1.2-7.046a4.629 4.629 0 00-1.892-1.383 10.592 10.592 0 00-2.982-.652v3.136a.716.716 0 01-.436.733.782.782 0 01-.291.081.629.629 0 01-.509-.244L4.509 7.781a.854.854 0 010-1.14L10.218.247a.569.569 0 01.764-.163.751.751 0 01.436.733v3.258c3.055.244 5.273 1.14 6.691 2.769C19.382 8.308 20 10.429 20 13.239z"
                fill="#8f99dc"
            />
        </svg>
    );
};

export default SendReply;
